// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"19192161","566":"939b2fcb"}[chunkId] + ".chunk.js";
};